// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {useState, useCallback} from 'react';
import _isEqual from 'lodash.isequal';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
// @ts-ignore
import cookie from 'cookie';
// @ts-ignore
import {get_browser} from 'hola_pub_util';
import {guess_os_and_version} from '../../client_hints_global';
// @ts-ignore
import {notify_survey_done} from '../../be.js';

export const use_survey = (json: i_survey_json, country_code)=>{
    const [done, set_done] = useState(false);
    const [active, set_active] = useState(0);
    const [answers, set_answers] = useState({});
    const save:t_survey_save = (qid, answer, text)=>{
        set_answers(prev_answers=>{
            let modified = (prev_answers[qid]||{}).modified ||
                !_isEqual(prev_answers[qid], {answer, text});
            return {...prev_answers, [qid]: {answer, text, modified}};
        });
    };
    const send = useCallback(()=>etask(function*(){
        const user_id = cookie.get('h_visitor_id');
        const browser = get_browser();
        const os = guess_os_and_version().os;
        for (const k in answers)
        {
            if (!answers[k].modified)
                continue;
            const {answer, text} = answers[k];
            try {
                const body = {
                    survey_id: k,
                    answers: Array.isArray(answer) ? answer : [answer],
                    text_note: text,
                    user_id,
                    country_code,
                    browser,
                    os,
                };
                yield fetch('/surveys', {method: 'POST', body});
                set_answers(prev_answers=>({...prev_answers, [k]: {answer,
                    text, modified: false}}));
            } catch(e){ console.log(e); }
        }
    }), [answers]);
    const next = ()=>{
        send();
        if (active < json.pages.length - 1)
            set_active(active+1);
        else
        {
            set_done(true);
            notify_survey_done();
        }
    };
    const prev = ()=>{
        if (done)
        {
            set_active(0);
            set_done(false);
        }
        else
            set_active(active-1);
    };
    return {active, set_active, answers, next, prev, save, done};
};
